import './apis.tpl.html';
import '../api/api';

/**
 * admin.apis module used for the apis view.
 */
angular
  .module('admin.apis', [
    'admin.api',
    // including this allows html in the data bound scope properties.
    'ngSanitize'
  ])
  .controller('AdminAPIsCtrl', function ($scope, $filter, API_TYPES, $state) {
    $scope.APIS = API_TYPES;
    $scope.apiView = API_TYPES.REST_API;

    const state = $state.current.name;

    $scope.apiConfiguration = {
      [API_TYPES.REST_API]: {
        api: API_TYPES.REST_API,
        state
      },
      [API_TYPES.BULK_API]: {
        api: API_TYPES.BULK_API,
        state
      }
    };

    /**
     * Show the passed view.
     * @param view {string} The view. Must be one of the views defined in the VIEWS constant.
     */
    $scope.showView = function (view) {
      $scope.apiView = view;
    };
  });
